import { render, staticRenderFns } from "./gzBindPhoneTemplate.vue?vue&type=template&id=a2a033fc&"
import script from "./gzBindPhoneTemplate.vue?vue&type=script&lang=js&"
export * from "./gzBindPhoneTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports